import { FormError, SubmitResult } from '@shopify/react-form';
import { NavigateFunction } from 'react-router-dom';

import { ShowMessage } from '../hooks/useMessage';
import { delay } from './misc';
import { handleError } from './errorHandling';


export interface SubmitConfig {
  request: any;
  redirectUrl?: string;
  replace?: boolean;
  nextStepFields?: string[],
}

export const formSubmitHandler = async (
  navigate: NavigateFunction,
  config: SubmitConfig,
  payload: any,
  showMessage?: ShowMessage,
): Promise<SubmitResult> => {
  const {
    request,
    redirectUrl,
    replace = false,
    nextStepFields = [],
  } = config;

  try {
    await request(payload);
    let locationState: Record<string, any> | null = null;

    if (redirectUrl) {
      if (nextStepFields.length) {
        locationState = nextStepFields.reduce((acc, key: string) => {
          return {
            ...acc,
            [key]: payload[key],
          };
        }, {});
      }

      delay(0, () => { navigate(redirectUrl, { replace, state: locationState }); });
    }

    return { status: 'success' };
  } catch (err) {
    const { validationErrors = [] }: { validationErrors: FormError[] } = handleError(err, showMessage, navigate) || {};
    return { status: 'fail', errors: validationErrors };
  }
};
